module.exports = "https://www.gc-qa.gnp.com.mx/f5a7c6a08206e6a8285083ff37022a56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-registro-poliza.svg
// module id = 1836
// module chunks = 0